export enum DashboardClassNames {
  ICICI = 'icici-eazypro',
  LK = 'lending-kart',
  IDFC = 'idfc',
  AXIS = 'axis-easypayplus',
  DEFAULT = 'default',
}
export enum Environment {
  TEST = 'test',
  SANDBOX = 'sandbox',
  PROD = 'prod',
}
